<template>
  <div>
    <div class="wheel_list mt-20 flex">
      <div class="wheel_one mr-15 cursor_pointer" v-for="(item, index) in wheelList" :key="index"
        :class="[item.value == selectWheel ? 'wheel_one_active' : '']" @click="changeWheel(item)">
        {{ item.label }}
      </div>
    </div>
    <div class="course_introduce" v-if="courseChapterList.length">
      <div class="course_introduce_content" ref="content" :class="{ expanded: isExpanded }">
        <div class="course_outline" v-for="(item, index) in courseChapterList" :key="index">
          <div class="course_one1" :class="[item.isExpanded ? '' : 'course_one_max']">
            <div class="course_outline_top flex FlexBetween Flexalign" v-if="!$Tools.empty(item.children)">
              <div class="course_outline_top_left flex Flexalign flex-1 toverflow">
                <el-image class="equal" :src="imgPath('equal.png')" @click="retractChapter(item)"></el-image>
                <!-- <div class="course_chapter">{{ item.chapter }}</div> -->
                <div class="course_chapter flex-1 toverflow">
                  {{ item.chapterName }}
                </div>
                <div class="course_hour">
                  （{{
                    $Tools.secondToHour(Number(item.totalSecond)) +
                    " " +
                    item.totalChapter +
                    "节"
                  }}）
                </div>
                <!-- <div class="course_hour">{{ item.chapterNumbers + "节" }}）</div> -->
              </div>
              <div class="cursor_pointer">
                <el-icon color="#999999">
                  <ArrowUp v-if="item.isExpanded" @click="retractChapter(item)" />
                  <ArrowDown v-else @click="retractChapter(item)" />
                </el-icon>
              </div>
            </div>
            
          <div v-else>
            <courseTitleList :courseOutline="item" :courseValue="courseValue" @changeCourseValue="changeCourseValue"
                :courseDetail="courseDetail" :isAleadyJoin="isAleadyJoin" v-if="courseDetail"
                @checkOverflow="checkOverflow" @showWheel="showWheel">
              </courseTitleList>
          </div>
            <div v-if="item.children">
              <courseTitleList :courseOutline="item" :courseValue="courseValue" @changeCourseValue="changeCourseValue"
                :courseDetail="courseDetail" :isAleadyJoin="isAleadyJoin" v-if="courseDetail"
                @checkOverflow="checkOverflow" @showWheel="showWheel">
              </courseTitleList>
            </div>
          </div>
        </div>
      </div>
      <div class="more_load flex Flexalign Flexjustify cursor_pointer" v-if="showLoadMore" @click="toggleExpand">
        {{ isExpanded ? "收起" : "展开更多" }}
        <el-icon>
          <ArrowDown v-if="showLoadMore && !isExpanded" />
          <ArrowUp v-if="showLoadMore && isExpanded" />
        </el-icon>
      </div>
    </div>
    <div v-else>
      <moe-empty url="moe_empty_bg_img.png" emptyText="暂无课程大纲"></moe-empty>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import courseTitleList from "./courseTitleList.vue";
export default {
  name: "GjkcH5CourseOutline",
  props: {
    courseId: {},
    courseDetail: {},
    isAleadyJoin: {},
  },
  components: {
    courseTitleList,
  },
  computed: {
    ...mapState({
      courseScheme: (state) => state.learning.courseScheme,
    }),
  },

  data() {
    return {
      isExpanded: false,
      showLoadMore: false,
      courseValue: "",
      courseList: [],
      courseChapterList: [],
      wheelList: [],
      selectWheel: 1,
      schemeList: [],
      schemeId: "",
      phaseIdIndex: 1,
    };
  },
  mounted() {
    // 获取轮次
    this.getRoundDict();
  },

  methods: {
    // 查找阶段位置的核心方法
    findPhasePosition(treeData, targetChapterId, targetPhaseId) {
      let globalCounter = 0; // 全局阶段计数器
      let foundIndex = -1; // 目标阶段位置

      // 深度优先遍历函数
      function dfs(nodes) {
        for (const node of nodes) {
          // 关键判断：是否为包含阶段列表的叶子节点
          const isLeafWithPhases =
            !Array.isArray(node.children) && node.phaseVoList;

          if (isLeafWithPhases) {
            // 双重验证：章节ID匹配且包含阶段列表
            if (node.phaseVoList) {
              for (const phase of node.phaseVoList) {
                globalCounter++; // 全局序号递增
                // 双重匹配：章节ID和阶段ID同时匹配
                if (
                  node.chapterId == targetChapterId &&
                  phase.phaseId == targetPhaseId
                ) {
                  foundIndex = globalCounter;
                  return true; // 找到后立即终止
                }
              }
            }
          } else if (Array.isArray(node.children)) {
            // 递归遍历子节点
            if (dfs(node.children)) return true;
          }
        }
        return false;
      }

      // 执行遍历
      if (Array.isArray(treeData) && treeData.length > 0) {
        dfs(treeData);
      }
      return foundIndex;
    },
    // 给章节下阶段配置是否可点击开始学习按钮字段
    addGlobalPhaseOrder(treeData) {
      const dfs = (nodes) => {
        for (const node of nodes) {
          const isLeafWithPhases =
            !Array.isArray(node.children) && node.phaseVoList;

          if (isLeafWithPhases && node.phaseVoList) {
            // 关键修改：重新赋值 phaseVoList
            node.phaseVoList = node.phaseVoList.map((item) => {
              const phaseIdIndex = this.findPhasePosition(
                this.courseChapterList,
                node.chapterId,
                item.phaseId
              );

              // 返回新对象（保留原属性）
              return {
                ...item,
                showLearningBtn: phaseIdIndex <= this.phaseIdIndex + 1,
              };
            });
          } else if (Array.isArray(node.children)) {
            dfs(node.children); // 移除条件判断，保证完整遍历
          }
        }
      };

      if (Array.isArray(treeData) && treeData.length > 0) {
        dfs(treeData);
      }
    },
    // getSchemeByCourseId() {
    //   this.$Api.course
    //     .getSchemeByCourseId(this.courseId)
    //     .then((res) => {
    //       this.schemeList = res.data.data;
    //       this.schemeId = res.data.data[0]?.schemeId;
    //       // 获取章节列表
    //       this.getCourseChapter();
    //     })
    //     .catch(() => {});
    // },
    getRoundDict() {
      this.$Api.course
        .getRoundDict()
        .then((res) => {
          for (var key in res.data.data) {
            this.wheelList.push({ label: res.data.data[key], value: key });
          }
          // 获取方案
          // this.getSchemeByCourseId();
          // 获取章节列表
          this.getCourseChapter();
        })
        .catch(() => { });
    },
    changeWheel(info) {
      this.selectWheel = info.value;
      this.getCourseChapter();
    },
    checkOverflow() {
      if (!this.$refs.content) return;
      setTimeout(() => {
        this.showLoadMore =
          this.$refs.content.scrollHeight > this.$refs.content.clientHeight;
      }, 500);
    },
    toggleExpand() {
      this.isExpanded = !this.isExpanded;
    },
    // 收起课程大纲
    retractChapter(info) {
      info.isExpanded = !info.isExpanded;
      this.checkOverflow();
    },
    // 获取课程章节列表
    getCourseChapter() {
      console.log(this.courseId)
      console.log(this.selectWheel)
      console.log(this.courseScheme)
      if (!this.courseId || !this.selectWheel || !this.courseScheme) {
        return
      }
      // 此处方案默认为第一个
      this.$Api.course
        .getCourseChapterNew({
          courseId: this.courseId,
          roundId: this.selectWheel,
          schemeId: this.courseScheme,
        })
        .then((res) => {
          let courseChapterList = res.data.data;
          this.courseChapterList = this.$Tree.handleTree(
            courseChapterList,
            "chapterId",
            "parentId"
          );
          // 统计时长
          this.courseChapterList = this.getAllChildren(this.courseChapterList);
          this.addWheelToLeafNodes(this.courseChapterList);
          setTimeout(() => {
            this.checkOverflow();
            this.getMyCourseProgress();
          }, 500);
        })
        .catch((err) => {
          // this.$Dialog.toast(err.data.message, { type: "error" });
          console.log(err);
        });
    },
    // 做递归统计
    getAllChildren(arr) {
      // 递归计算单个节点的总时长
      const calc = (node) => {
        let total = node.chapterResource.videoDuration || 0; // 基础值
        let totalChapter = 0; // 统计章节数
        if (node.children?.length) {
          // 有子节点时递归
          total += node.children.reduce(
            (sum, child) => sum + calc(child).total,
            0
          );
          totalChapter += node.children.length;
        }
        return {
          total,
          totalChapter,
        };
      };

      // 处理第一层并返回新数组
      return arr.map((item) => ({
        ...item, // 保留原有属性
        totalSecond: calc(item).total, // 添加统计结果
        totalChapter: calc(item).totalChapter,
        isExpanded: true, // 第一层默认展开状态
      }));
    },
    // 自配四轮
    addWheelToLeafNodes(nodes) {
      for (const node of nodes) {
        // 判断是否是叶子节点（children为null或空数组）
        const isLeaf =
          !node.children ||
          (Array.isArray(node.children) && node.children.length === 0);

        if (isLeaf) {
          // 给叶子节点添加wheel属性
          node.wheel = false; // 或自定义属性值
          // (node.wheelList = [
          //   { label: "导入", value: 1 },
          //   { label: "理解", value: 2 },
          //   { label: "变式", value: 3 },
          //   { label: "综合", value: 4 },
          // ]),
          //   (node.wheelStage = 1);
        } else if (Array.isArray(node.children)) {
          // 递归处理子节点
          this.addWheelToLeafNodes(node.children);
        }
      }
    },
    // 四轮显示
    showWheel(nodes, chapterId) {
      console.log(nodes,3333)
      // 只有章节的时候没有children直接取反值
      if(this.$Tools.empty(nodes)){
        let selectedChapterInfo = this.courseChapterList.find(item => item.chapterId == chapterId);
        selectedChapterInfo.wheel = !selectedChapterInfo.wheel;
        console.log(selectedChapterInfo)
        return
      }
      for (const node of nodes) {
        // 判断是否是叶子节点（children为null或空数组）
        const isLeaf =
          !node.children ||
          (Array.isArray(node.children) && node.children.length === 0);

        if (isLeaf) {
          if (node.chapterId == chapterId) {
            // node.wheel = true;
            node.wheel = !node.wheel;
          } else {
            node.wheel = false;
          }
        } else if (Array.isArray(node.children)) {
          // 递归处理子节点
          this.showWheel(node.children);
        }
      }
    },
    // 选中课程
    changeCourseValue(chapterId) {
      this.courseValue = chapterId;
    },
    // 获取课程最新学习章节
    getMyCourseProgress() {
      this.$Api.course
        .getMyCourseProgress({ courseId: this.courseId })
        .then((res) => {
          // 判断是否有章节Id，没有证明第一次学习，默认展示第一个章节的第一阶段
          if (!res.data.data.chapterId) {
            // 判断当前学习进度在树形结构中排列结果
            this.phaseIdIndex = this.findPhasePosition(
              this.courseChapterList,
              this.allPlayerCourseList[0]?.chapterId,
              this.allPlayerCourseList[0].phaseVoList[0]?.phaseId
            );
          } else {
            this.phaseIdIndex = this.findPhasePosition(
              this.courseChapterList,
              res.data.data.chapterId,
              res.data.data.phaseId
            );
          }
          this.addGlobalPhaseOrder(this.courseChapterList);
        })
        .catch(() => {});
    },
  },
};
</script>
<style lang="scss" scoped>
.wheel_list {
  .wheel_one {
    width: 82px;
    height: 36px;
    background: #f6f6f5;
    border-radius: 18px;
    line-height: 36px;
    text-align: center;
    color: #111110;
  }

  .wheel_one_active {
    background: linear-gradient(97deg, #00d498 0%, #00d5c2 100%);
    color: #ffffff;
  }
}

.course_introduce {
  // max-height: 550px;
  // overflow: hidden;
  position: relative;

  .course_introduce_content {
    max-height: 600px;
    overflow: hidden;

    .course_outline {
      margin-top: 20px;

      .course_one_max {
        max-height: 28px;
        overflow: hidden;
      }

      .course_outline_top {
        .equal {
          width: 28px;
          height: 28px;
        }

        .course_chapter {
          margin-left: 10px;
          font-weight: bold;
          font-size: 18px;
          color: #333333;
        }

        .course_hour {
          margin-left: 5px;
          font-weight: 400;
          font-size: 16px;
          color: #999999;
        }
      }

      // .course_subChapter {
      //   margin-top: 15px;
      //   margin-left: 40px;

      //   .subChapter_top {
      //     .subChapter_top_left_subChapter {
      //       margin-left: 5px;
      //       color: #333333;
      //       font-size: 18px;
      //       font-weight: 600;
      //     }
      //   }

      //   .subChapterList {
      //     margin-top: 10px;

      //     .subChapterList_one {
      //       line-height: 40px;
      //       color: #999999;

      //       .select_play {
      //         margin-right: 10px;
      //         width: 18px;
      //         height: 18px;
      //       }

      //       .btn_learn {
      //         width: 80px;
      //         height: 34px;
      //         background: linear-gradient(90deg, #00d5c2, #00d498);
      //         border-radius: 17px;
      //         color: #ffffff;
      //         line-height: 34px;
      //         margin-right: 10px;
      //         text-align: center;
      //       }
      //     }

      //     .active_subChapterList_one {
      //       background: #fafcff;
      //       color: #13d6aa;
      //     }
      //   }
      // }
    }
  }

  .course_introduce_content.expanded {
    max-height: none;
    overflow: visible;
    /* 展开后高度 */
  }

  .more_load {
    width: 100%;
    height: 50px;
    background: #ffffff;
    border-radius: 0px 0px 20px 20px;
    // position: absolute;
    // bottom: 0;
    z-index: 9;
    color: #999999;
  }
}
</style>
